<!--  -->
<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="应用id" label-width="150px">
          <el-input v-model="form.suite_id" />
        </el-form-item>
        <el-form-item label="应用名称" label-width="150px">
          <el-input v-model="form.suite_name" />
        </el-form-item>
        <el-form-item label="服务商企业id" label-width="150px">
          <el-input v-model="form.corp_id" />
        </el-form-item>
        <el-form-item label="服务商企业名称" label-width="150px">
          <el-input v-model="form.corp_name" />
        </el-form-item>
        <el-form-item label="token" label-width="150px">
          <el-input v-model="form.token" />
        </el-form-item>
        <el-form-item label="encoding_aes_key" label-width="150px">
          <el-input v-model="form.encoding_aes_key" />
        </el-form-item>
        <el-form-item label="secret" label-width="150px">
          <el-input v-model="form.secret" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="addcread">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding:0 20px">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width:100%;"
        border
        max-height="400"
      >
        <el-table-column
          align="center"
          prop="suite_id"
          label="应用id"
          width="150"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.suite_id }}</span>
            <el-input v-else v-model="scope.row.textSuiteid" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="suite_name"
          label="应用名称"
          width="130"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.suite_name }}</span>
            <el-input v-else v-model="scope.row.textSuitename" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="corp_id"
          label="服务商企业id"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.corp_id }}</span>
            <el-input v-else v-model="scope.row.textCorpId" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="corp_name"
          label="服务商企业名称"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.corp_name }}</span>
            <el-input v-else v-model="scope.row.textCorpname" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="token"
          label="token"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.token }}</span>
            <el-input v-else v-model="scope.row.textToken" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="encoding_aes_key"
          label="encoding_aes_key"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.encoding_aes_key }}</span>
            <el-input v-else v-model="scope.row.textEncodingaeskey" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="secret"
          label="secret"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.isModify">{{ scope.row.secret }}</span>
            <el-input v-else v-model="scope.row.textSecret" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="corp_name"
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="copyauthlink(scope.row)">查看授权链接</el-button>
            <!-- <el-button v-show="!scope.row.isModify" type="text" size="mini" @click="edit(scope.row)">修改</el-button> -->
            <span v-show="scope.row.isModify">
              <el-button type="text" size="small" @click.native.prevent="(scope.row.isModify = false)">取消修改</el-button>
              <el-button type="text" size="small" @click.native.prevent="confirmAccount(scope.row)">确认修改</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      v-loading="loadinglink"
      title="查看授权链接"
      :visible.sync="lookpassword"
      :append-to-body="true"
    >
      <div>
        <!-- <div style="width:450px;line-height:25px;color:rgb(0, 98, 190)">
          {{ password }}
        </div>
        <el-button
          v-clipboard:copy="password"
          v-clipboard:success="onCopys"
          v-clipboard:error="onErrors"
          style="margin-top:15px"
          type="primary"
          size="mini"
        >复制授权链接</el-button> -->
        <iframe
          v-if="password === null ? false : true"
          width="100%"
          height="580"
          marginwidth="0"
          marginheight="0"
          frameborder="0"
          scrolling="no"
          :src="password"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSuiteList, getSuiteListcreate, delteMicro, wechatcomupdataaccountr, updateDepartment, builderAuthUrl } from '@/api/providerAccountManagement/servicePorviderList2.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      form: {
        suite_id: '',
        suite_name: '',
        token: '',
        encoding_aes_key: '',
        secret: '',
        corp_id: '',
        corp_name: ''
      },
      loadinglink: false,
      password: null,
      lookpassword: false,
      stutes: null,
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,
      tableData: [],
      loading: false,
      query: {
        page: 1,
        pageSize: 10
      },
      total: null,

      company_name: '',
      ster: null
    }
  },
  created() {
    this.accountlist()
  },
  mounted() {

  },
  methods: {
    async accountlist() {
      this.loading = true
      const data = await getSuiteList(this.query)
      for (let i = 0; i < data.data.list.length; i++) {
        data.data.list[i].textSuiteid = data.data.list[i].suite_id
        data.data.list[i].textSuitename = data.data.list[i].suite_name
        data.data.list[i].textToken = data.data.list[i].token
        data.data.list[i].textEncodingaeskey = data.data.list[i].encoding_aes_key
        data.data.list[i].textSecret = data.data.list[i].secret
        data.data.list[i].textCorpId = data.data.list[i].corp_id
        data.data.list[i].textCorpname = data.data.list[i].corp_name

        data.data.list[i].isModify = false
      }
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
    },
    async addcread() {
      if (this.form.suite_id === '') {
        this.$message.error('请填写服务商id')
        return
      }
      if (this.form.suite_name === '') {
        this.$message.error('请填写服务名称')
        return
      }
      if (this.form.token === '') {
        this.$message.error('请填写token')
        return
      }
      if (this.form.encoding_aes_key === '') {
        this.$message.error('请填写encoding_aes_key')
        return
      }
      if (this.form.secret === '') {
        this.$message.error('请填写secret')
        return
      }
      if (this.form.corp_id === '') {
        this.$message.error('请填写corp_id')
        return
      }
      if (this.form.corp_name === '') {
        this.$message.error('请填写corp_name')
        return
      }

      await getSuiteListcreate(this.form)
      this.accountlist()
      this.rest()
      this.$message({
        message: '添加成功',
        type: 'success'
      })
    },

    rest() {
      this.form.suite_id = ''
      this.form.suite_name = ''
      this.form.token = ''
      this.form.encoding_aes_key = ''
      this.form.secret = ''
      this.form.corp_id = ''
      this.form.corp_name = ''
    },
    edit(row) {
      row.isModify = true
    },
    // 确定修改
    async confirmAccount(item) {
      // const id = item.id
      console.log('56555', item)
      // if (item.textvideoAccount === '') {
      //   this.$message.error('请填写视频号')
      //   return
      // }
      const data = await wechatcomupdataaccountr({
        id: item.id,
        suiteid: item.textSuiteid,
        suite_name: item.textSuitename,
        token: item.textToken,
        encoding_aes_key: item.textEncodingaeskey,
        secret: item.textSecret,
        corp_id: item.textCorpId,
        corp_name: item.textCorpname
      })
      this.accountlist()
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      console.log(data)
    },

    // 删除
    async deleteAccount(id) {
      await delteMicro(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
    },

    async updateDepartment(id) {
      await updateDepartment({ corp_id: id })
      await this.accountlist()
      this.$message({
        message: '更新成功',
        type: 'success'
      })
    },

    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    },
    async statusChange(item) {
      console.log('item', item.kf_status)
      const data = await wechatcomupdataaccountr({
        id: item.id,
        corp_id: item.textCorpId,
        corp_name: item.textCorpName,
        secret: item.textSecret,
        token: item.textToken,
        aes_key: item.textAeskey,
        video_account: item.textvideoAccount,
        customer_contact_secret: item.customercontactSecret,
        kf_status: item.kf_status === 1 ? 1 : 9
      })
      this.accountlist()
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      console.log(data)
    },
    async copyauthlink(item) {
      console.log(item)
      this.loadinglink = true
      const data = await builderAuthUrl({
        suite_id: item.suite_id
      })
      this.password = data.data.auth_url
      this.lookpassword = true
      this.loadinglink = false
      console.log('data', data)
    },
    onCopys() {
      this.$message({
        message: '复制授权链接成功',
        type: 'success'
      })
      // this.lookpassword = false
    },
    onErrors() {
      this.$message.error('复制授权链接失败')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  /* margin-top: 30px; */
  padding: 10px 10px 0px 10px;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}
.titip{
    width: 126px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
